import { Body2, Headline2, Headline5 } from 'stories/elements/Typography/Text'
import theme from 'stories/utils/theme'
import RotatingReviews from 'stories/V1/sections/RotatingReviews'
import styled from 'styled-components'
import StarIcon from 'assets/homepage-redesign/star.svg'
import Row from 'components/elements/Row'
import { KnowunityNumbers } from 'lib/constants/KnowunityNumbers'

const ReviewsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    background-color: #061c31;
    border-radius: 48px;
    padding: 75px 0 50px;
    @media (max-width: 740px) {
        padding: 40px 0 25px;
        gap: 0px;
        border-radius: ${theme.borderRadius.rounded};
    }
    h2 {
        padding: 0 25% !important;
        font-family: var(--font-inter);
        font-weight: 650;
        font-size: 30px;
        line-height: 36px;
        letter-spacing: -0.4px;
        span {
            all: inherit;
            padding: 0px;
            display: inline;
            color: #797fdd;
        }
        @media (max-width: 740px) {
            padding: 0px 10% !important;
            font-family: var(--font-inter);
            font-weight: 650;
            font-size: 23px;
            line-height: 28px;
            letter-spacing: -0.2px;
        }
    }
    .store-reviews {
        display: flex;
        justify-content: center;
        gap: 12px;
        padding: 24px;
        @media (max-width: 740px) {
            gap: 8px;
            padding: 24px 24px 0px 24px;
        }
        .store-review-item {
            position: relative;
            display: flex;
            align-items: center;
            gap: 8px;
            background-color: ${theme.colors.backgroundTransparent};
            border-radius: 24px;
            padding: 14px 18px 14px 8px;
            & > div {
                position: relative;
                left: -5px;
            }
            svg {
                position: relative;
                left: 5px;
                scale: 0.7;
            }

            h5 {
                color: ${theme.colors.white};
                font-size: 20px;
                line-height: 24px;
                font-weight: 650;
                letter-spacing: 0px;
                margin: 0;
                span {
                    all: inherit;
                    display: inline-block;
                    padding: 0 4px;
                    color: ${theme.colors.sunlightYellow};
                }
            }

            p {
                color: ${theme.colors.grayScaleSecondary};
                font-size: 14px;
                font-weight: 450;
                line-height: 20px;
                letter-spacing: 0.4px;
                margin: 0;
            }
            @media (max-width: 860px) {
                flex-direction: column;
                width: 100%;
                padding: 8px 16px;
                gap: 0px;
                p {
                    font-size: 14px;
                }
            }
        }
    }
`

const CareersReviews = () => {
    const topReviews = [
        {
            name: 'Stefan S, iOS user',
            text: 'The app is very easy to use and well designed. I have found everything I was looking for so far and have been able to learn a lot from the presentations! I will definitely use the app for a class assignment! And of course it also helps a lot as an inspiration.',
            stars: 5,
        },
        {
            name: 'Samantha Klich, Android user',
            text: 'This app is really great. There are so many study notes and help [...].  My problem subject is French, for example, and the app has so many options for help. Thanks to this app, I have improved my French. I would recommend it to anyone.',
            stars: 5,
        },
        {
            name: 'Anna, iOS user',
            text: "Wow, I am really amazed. I just tried the app because I've seen it advertised many times and was absolutely stunned. This app is THE HELP you want for school and above all, it offers so many things, such as workouts and fact sheets, which have been VERY helpful to me personally.",
            stars: 5,
        },
        {
            name: 'Thomas R, iOS user',
            text: "Best app on earth! no words because it's too good",
            stars: 5,
        },
        {
            name: 'Basil, Android user',
            text: "Just amazing. Let's me revise 10x better, this app is a quick 10/10. I highly recommend it to anyone. I can watch and search for notes. I can save them in the subject folder. I can revise it any time when I come back. If you haven't tried this app, you're really missing out.",
            stars: 5,
        },
        {
            name: 'David K, iOS user',
            text: 'This app has made me feel so much more confident in my exam prep, not only through boosting my own self confidence through the features that allow you to connect with others and feel less alone, but also through the way the app itself is centred around making you feel better. It is easy to navigate, fun to use, and helpful to anyone struggling in absolutely any way.',
            stars: 5,
        },
        {
            name: 'Sudenaz Ocak, Android user',
            text: "The app's just great! All I have to do is enter the topic in the search bar and I get the response real fast. I don't have to watch 10 YouTube videos to understand something, so I'm saving my time. Highly recommended!",
            stars: 5,
        },
        {
            name: 'Greenlight Bonnie, Android user',
            text: 'In school I was really bad at maths but thanks to the app, I am doing better now. I am so grateful that you made the app.',
            stars: 5,
        },
        {
            name: 'Rohan U, Android user',
            text: "very reliable app to help and grow your ideas of Maths, English and other related topics in your works. please use this app if your struggling in areas, this app is key for that. wish I'd of done a review before. and it's also free so don't worry about that.",
            stars: 5,
        },
        {
            name: 'Xander S, iOS user',
            text: "I know a lot of apps use fake accounts to boost their reviews but this app deserves it all. Originally I was getting 4 in my English exams and this time I got a grade 7. I didn't even know about this app three days until the exam and it has helped A LOT. Please actually trust me and use it as I'm sure you too will see developments.",
            stars: 5,
        },
        {
            name: 'Elisha, iOS user',
            text: 'THE QUIZES AND FLASHCARDS ARE SO USEFUL AND I LOVE THE SCHOOLGPT. IT ALSO IS LITREALLY LIKE CHATGPT BUT SMARTER!! HELPED ME WITH MY MASCARA PROBLEMS TOO!! AS WELL AS MY REAL SUBJECTS ! DUHHH 😍😁😲🤑💗✨🎀😮',
            stars: 5,
        },
        {
            name: 'Paul T, iOS user',
            text: 'This apps acc the goat. I find revision so boring but this app makes it so easy to organize it all and then you can ask the freeeee ai to test yourself so good and you can easily upload your own stuff. highly recommend as someone taking mocks now',
            stars: 5,
        },
    ]

    return (
        <ReviewsContainer>
            <Headline2
                textAlign="center"
                color={theme.colors.white}
                fontSize={30}
                fontFamily="var(--font-inter)"
                fontWeight={550}
            >
                Our impact: <span>millions of students succeeding</span>
            </Headline2>
            <div className="store-reviews">
                <div className="store-review-item">
                    <Row gap={3}>
                        <StarIcon />
                        <Headline5 fontFamily="var(--font-inter)">{KnowunityNumbers.appleReviewRating}/5</Headline5>
                    </Row>
                    <Body2 fontFamily="var(--font-inter)">App Store</Body2>
                </div>
                <div className="store-review-item">
                    <Row gap={3}>
                        <StarIcon />
                        <Headline5 fontFamily="var(--font-inter)">{KnowunityNumbers.googleReviewRating}/5</Headline5>
                    </Row>
                    <Body2 fontFamily="var(--font-inter)">Google Play</Body2>
                </div>
            </div>
            <RotatingReviews reviews={topReviews} />
        </ReviewsContainer>
    )
}

export default CareersReviews
